export enum ArticleContentVariation {
  Text = 'text',
  TextAndImage = 'text_and_image',
  TextAndRoundImage = 'big_text_and_round_image',
  TextOnImage = 'text_on_image',
  TextBoxDashed = 'text_box_dashed',
  TextBoxSolid = 'text_box_solid',
  ReflectionBox = 'reflection_box',
}
